// const BrandLogo = () => {
//   return (
//     <div className="login_logo-text">
//       TrueL
//       <span className="i-wrapper">
//         i<span className="login_red-dot "></span>
//       </span>
//       ft Media
//     </div>
//   );
// };

// export default BrandLogo;

import logo from "../../assets/img/icons/login_page_logo.png";
import sideBarLogo from "../../assets/img/icons/sidbar_logo.png";

export const BrandLogo = () => {
  return (
    <div className="login_logo-text d-flex align-items-center">
      <img
        src={logo}
        alt="TrueLift Media Logo"
        className="login_logo-img mr-2"
      />
    </div>
  );
};

export const SideBarLogo = () => {
  return (
    <div className="login_logo-text d-flex align-items-center">
      <img
        src={sideBarLogo}
        alt="TrueLift Media Logo"
        className="sidebar_logo-img mr-2"
      />
    </div>
  );
};

export const SideBarLogoForLogin = () => {
  return (
    <div>
      <img
        src={logo}
        alt="TrueLift Media Logo"
        className="sidebar_logo_for_login-img "
      />
    </div>
  );
};